/**
 * Legend 관련 기능 구현
 *   - 상하좌우 위치 이동 등
 */

import BriqueChart from './BriqueChart.vue'
import { BRIQUECHART_LEGEND_POSITIONS } from './BriqueChartConst'

export default {
  /**
   * Plotly가 자동으로 만들어 놓은 범례의 스타일 수정
   * @param {Object} element Chart의 Element
   */
  restyleLegend (element) {
    if (_.isString(element)) element = document.querySelector(`#${element}`)

    let briqueChartOption = element.briqueChartOption
    let scrollBar = element.querySelector('.legend .scrollbar')
    if (scrollBar) {
      if (briqueChartOption.legend.position === 'right') {
        scrollBar.setAttribute('transform', 'translate(-6, 0)')// 범례 위치가 우측일때 스크롤바가 안보이는 것을 보정
      } else {
        scrollBar.setAttribute('transform', 'translate(0, 0)')
      }
    }
  },

  /**
   * 범례위치 정보로부터 Plotly의 Layout 객체 설정
   * @param {Object} element Chart Element
   * @param {Object} layout Plotly Layout 객체
   * @param {Object} briqueChartOption BriqueChart 옵션
   */
  setLayoutFromLegendPosition (element, layout = {}, briqueChartOption) {
    if (_.isString(element)) element = document.querySelector(`#${element}`)

    let index = BRIQUECHART_LEGEND_POSITIONS.findIndex(o => o.val === briqueChartOption.legend.position)
    let legendPosition = BRIQUECHART_LEGEND_POSITIONS[index]

    if (element.layout) { // Chart를 1번이라도 그렸으면
      if (legendPosition.val === 'bottom') {
        // let innerHeight = element.querySelector(`.nsewdrag`).getBBox().height // 차트 안쪽 부분
        let chartHeight = element.offsetHeight
        let xTickLabelHeight = element.querySelector(`.xaxislayer-above`)?.getBBox().height // X축 Label 영역
        let xTitleHeight = element.querySelector(`.g-xtitle`)?.getBBox().height // 타이틀 영역
        let rangesliderHeight = 0

        if (BriqueChart.getModeBarButton(element, 'rangeView').active) {
          rangesliderHeight = element.querySelector(`.rangeslider-container`)?.getBBox().height// Range View 영역
          if (_.isEmpty(rangesliderHeight)) {
            rangesliderHeight = chartHeight * 0.135
          }
        } else {
          rangesliderHeight = 0
        }

        rangesliderHeight = rangesliderHeight ? rangesliderHeight + 20 : rangesliderHeight
        let y = -((xTickLabelHeight + xTitleHeight + rangesliderHeight + 20) / (chartHeight - xTickLabelHeight - xTitleHeight - rangesliderHeight - briqueChartOption.legend.height - layout.margin.t))
        legendPosition.layout.legend.y = y > 0 ? 0 : y
      } else if (legendPosition.val === 'left') {
        // let innerWidth = element.querySelector(`.nsewdrag`).getBBox().width // 차트 안쪽 부분
        let chartWidth = element.offsetWidth
        let yTickLabelWidth = element.querySelector(`.yaxislayer-above`).getBBox().width // Y축 Label 영역
        let yTitleWidth = element.querySelector(`.g-ytitle`).getBBox().width // Y축 Label 영역

        let x = -(((yTickLabelWidth + yTitleWidth + 20)) / (chartWidth - yTickLabelWidth - yTitleWidth - briqueChartOption.legend.width - layout.margin.r))
        legendPosition.layout.legend.x = x > 0 ? 0 : x
      }
    }

    _.merge(layout, legendPosition.layout)
  }
}
